import { CategoryConstants } from '../_constants';

//-- add category reducer
export function addCategory(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.CATEGORY_ADDED_REQUEST:
      return {
        addedCat: false
      };

    case CategoryConstants.CATEGORY_ADDED_SUCCESS:
      //console.log("ASC ", action.user);
      return { addedCat:action.successAction};

    case CategoryConstants.CATEGORY_ADDED_FAILURE:
      return {
        addedCat: false,
      };

    default:
      return state
  }
}
 
//get all the categories from database
export function getCategories(state = {}, action) {
    switch (action.type) {
      case CategoryConstants.CATEGORY_GET_REQUEST:
        return {
          getCatList: false
        };
  
      case CategoryConstants.CATEGORY_GET_SUCCESS:
        //console.log("ASC ", action.user);
        return { getCatList:action.successAction};
  
      case CategoryConstants.CATEGORY_GET_FAILURE:
        return {
          getCatList: false,
        };
  
      default:
        return state
    }
  }

//get all the sub categories from database
export function getAllSubCategory(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.SUB_CATEGORY_GET_REQUEST:
      return {
        getSubCatList: false
      };

    case CategoryConstants.SUB_CATEGORY_GET_SUCCESS:
      //console.log("ASC ", action.user);
      return { getSubCatList:action.successAction};

    case CategoryConstants.SUB_CATEGORY_GET_FAILURE:
      return {
        getSubCatList: false,
      };

    default:
      return state
  }
}
  
// Get specific category by id
export function getCategory(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.CATEGORY_BY_ID_REQUEST:
      return {
        editCatData: false
      };

    case CategoryConstants.CATEGORY_BY_ID_SUCCESS:
      //console.log("ASC ", action.user);
      return { editCatData:action.successAction};

    case CategoryConstants.CATEGORY_BY_ID_FAILURE:
      return {
        editCatData: false,
      };

    default:
      return state
  }
}


// Edit category by id
export function editCategory(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.CATEGORY_EDIT_REQUEST:
      return {
        editedCat: false
      };

    case CategoryConstants.CATEGORY_EDIT_SUCCESS:
      //console.log("ASC ", action.user);
      return { editedCat:action.successAction};

    case CategoryConstants.CATEGORY_EDIT_FAILURE:
      return {
        editedCat: false,
      };

    default:
      return state
  }
}



// GET active categories
export function getAllActiveCat(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.CATEGORY_GET_ACTIVE_REQUEST:
      return {
        activeCat: false
      };

    case CategoryConstants.CATEGORY_GET_ACTIVE_SUCCESS:
      //console.log("ASC ", action.user);
      return { activeCat:action.successAction};

    case CategoryConstants.CATEGORY_GET_ACTIVE_FAILURE:
      return {
        activeCat: false,
      };

    default:
      return state
  }
}


// Delete  category
export function deleteCategory(state = {}, action) {
  switch (action.type) {
    case CategoryConstants.CATEGORY_DELETE_REQUEST:
      return {
        deleteCat: false
      };

    case CategoryConstants.CATEGORY_DELETE_SUCCESS:      
      return { deleteCat:action.successAction};

    case CategoryConstants.CATEGORY_DELETE_FAILURE:
      return {
        deleteCat: false,
      };

    default:
      return state
  }
}


